window.Page = {

    filtersButton         : document.querySelector('.filters-button'),
    filtersIndicator      : document.querySelector('.filters-indicator'),
    filtersSection        : document.querySelector('.filters-container'),
    filtersActiveButton   : null,

    filters      : document.querySelectorAll('.filter-button'),
    filtersItems : document.querySelectorAll('.filters-category-item'),
    filtersLinks : document.querySelectorAll('.filter-link'),

    // Let's launch this thing
    liftoff : () => {
        Page.showHideFilters()
        Page.filterLinksAndProducts()
        //Page.automaticallyOpenFiltersOnDesktop()
    },

    // My new function block
    showHideFilters : () => {
        Page.filtersButton.addEventListener('click' , event => {

            Page.filtersIndicator.innerHTML = Page.filtersIndicator.innerHTML == '+' ? '-' : '+';
            Page.filtersSection.classList.toggle('hidden')

        })

        Page.filtersLinks.forEach(link => {
            link.addEventListener('click' , () => {
                Page.filtersIndicator.innerHTML = '-';
                Page.filtersSection.classList.toggle('hidden')
            })
        })
    },

    // Filter the products when a link is clicked
    filterLinksAndProducts : () => {

        Page.filters.forEach(filter => {
            filter.addEventListener('click' , () => {

                // We have clicked on the active filter so it's time to reset everything to default
                if (filter == Page.filtersActiveButton) {
                    filter.classList.remove('selected')
                    Page.filtersItems.forEach(item => { item.classList.remove('hidden','selected') })
                    Page.filtersActiveButton = null;
                    return;
                }
                

                if (Page.filtersActiveButton)
                    Page.filtersActiveButton.classList.remove('selected')

                Page.filtersActiveButton = filter;
                filter.classList.add('selected')

                // Now we need to filter out the products
                Page.filtersItems.forEach(item => {

                    // Remove all classes
                    item.classList.remove('hidden','selected')

                    // Check if it has the selected filter class
                    if (item.classList.contains(filter.value)) {
                        item.classList.add('selected')
                    } else {
                        item.classList.add('hidden')
                    }

                })
                

            })
        })

    },

    // Show open filters on desk
    automaticallyOpenFiltersOnDesktop : () => {

        if (window.matchMedia("(width > 1100px)").matches)
            Page.filtersButton.click()

    }

};

Page.liftoff()